import { ConfigProvider } from 'antd';

const AntdThemeProvider = ({ children }) => {
	const defaultComponentSize = 'middle';
	// const fieldBorderColor = '#d9e2ec';
	// const disabledFieldBgColor = '#f1f5f9';
	// const disabledFieldBorderColor = '#e2e8f0';
	const fieldBorderColor = '#cbd5e1';
	const fieldHoverBorderColor = '#94a3b8';
	const fieldActiveBorderColor = '#2563eb';
	const fieldBgColor = '#ffffff';
	const disabledFieldBgColor = '#f8fafc';
	const disabledFieldBorderColor = '#e2e8f0';
	const fieldTextColor = '#0f172a';
	const fieldPlaceholderColor = '#94a3b8';
	const labelColor = '#64748b';

	const customTheme = {
		components: {
			Input: {
				inputFontSize: 14,
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			InputNumber: {
				inputFontSize: 14,
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			Form: {
				labelFontSize: '14px',
				// labelColor: '#555',
				// labelColor: '#64748b',
				labelColor,
				verticalLabelPadding: '0 0 4px 0',
			},
			Select: {
				fontSize: 14,
				optionFontSize: 14,
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			Calendar: {
				fontSize: 14,
				fullBg: '#ffffff',
				itemActiveBg: '#f0f5ff',
			},
			DatePicker: {
				inputFontSize: 14,
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			TreeSelect: {
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			Cascader: {
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			Mentions: {
				// colorBorder: fieldBorderColor,
				colorBorder: fieldBorderColor,
				// hoverBorderColor: fieldBorderColor,
				hoverBorderColor: fieldHoverBorderColor,
				// activeBorderColor: fieldBorderColor,
				activeBorderColor: fieldActiveBorderColor,
				// activeShadow: `0 0 0 3px ${fieldOutlineColor}`,
				activeShadow: 'none',
				colorBgContainer: fieldBgColor,
				colorText: fieldTextColor,
				colorTextPlaceholder: fieldPlaceholderColor,
				colorBgContainerDisabled: disabledFieldBgColor,
			},
			Tree: {
				directoryNodeSelectedBg: '#e2ebf7',
				directoryNodeSelectedColor: '#000000',
			},
		},
		token: {
			// colorBgContainerDisabled: disabledFieldBgColor,
			colorBgContainerDisabled: disabledFieldBgColor,
			colorBgContainer: fieldBgColor,
			borderRadius: 8,
			// controlHeight: 44,
			// controlHeight: 38,
			controlHeight: 40,
			// borderRadiusLG: 8,
			// controlHeightLG: 44,
			// colorBorder: fieldBorderColor,
			colorBorder: fieldBorderColor,
			colorBorderBg: disabledFieldBorderColor,
			// colorPrimaryBorder: fieldBorderColor,
			colorPrimaryBorder: fieldActiveBorderColor,
			// colorPrimaryHover: fieldBorderColor,
			colorPrimaryHover: fieldHoverBorderColor,
			colorPrimary: fieldActiveBorderColor,
			colorText: fieldTextColor,
			colorTextPlaceholder: fieldPlaceholderColor,
			fontFamily: "'Inter', sans-serif",
			fontSizeLG: 16,
			colorTextDisabled: '#615353',
		},
	};

	return (
		<ConfigProvider theme={customTheme} componentSize={defaultComponentSize}>
			<style>
				{`
					.ant-input-disabled,
					.ant-input[disabled],
					.ant-input-affix-wrapper-disabled,
					.ant-input-number-disabled,
					.ant-input-number-disabled .ant-input-number-input,
					.ant-picker-disabled,
					.ant-select-disabled .ant-select-selector,
					.ant-cascader-disabled .ant-select-selector,
					.ant-tree-select-disabled .ant-select-selector,
					.ant-mentions-disabled,
					.ant-upload-wrapper .ant-upload-disabled.ant-upload-select {
						background-color: ${disabledFieldBgColor} !important;
						border-color: ${disabledFieldBorderColor} !important;
						box-shadow: none !important;
					}

					.ant-form-item .ant-form-item-label > label {
						color: ${labelColor} !important;
						font-weight: 500;
						letter-spacing: 0.01em;
					}

					.ant-input,
					.ant-input-affix-wrapper,
					.ant-input-number,
					.ant-select-selector,
					.ant-picker,
					.ant-mentions,
					.ant-input-number-group-addon,
					.ant-input-group-addon {
						background-color: ${fieldBgColor};
						border-color: ${fieldBorderColor};
						color: ${fieldTextColor};
						transition: all 0.2s ease;
					}

					.ant-input::placeholder,
					.ant-mentions textarea::placeholder,
					.ant-input-number-input::placeholder {
						color: ${fieldPlaceholderColor};
					}

					.ant-input:hover,
					.ant-input-affix-wrapper:hover,
					.ant-input-number:hover,
					.ant-select:not(.ant-select-disabled):hover .ant-select-selector,
					.ant-picker:hover,
					.ant-mentions:hover {
						border-color: ${fieldHoverBorderColor} !important;
					}

					.ant-input:focus,
					.ant-input-focused,
					.ant-input-affix-wrapper-focused,
					.ant-input-number-focused,
					.ant-select-focused .ant-select-selector,
					.ant-picker-focused,
					.ant-mentions-focused {
						border-color: ${fieldActiveBorderColor} !important;
						box-shadow: none !important;
						outline: none !important;
					}
				`}
			</style>
			{children}
		</ConfigProvider>
	);
};

export default AntdThemeProvider;
